import {
  KEY_CAMPAIGNS,
  KEY_DASHBOARD,
  KEY_DEVICE_MANAGEMENT,
  KEY_DEVICE_MANAGEMENT_BUILDINGS,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS,
  KEY_DEVICE_MANAGEMENT_DEVICES,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS,
  KEY_DEVICE_MANAGEMENT_FLOORS,
  KEY_DEVICE_MANAGEMENT_PROJECT,
  KEY_IMPORTANT,
  KEY_MANAGEMENT,
  KEY_MEDIAS,
  KEY_REPORTS,
  KEY_REPORTS_ACTION_LOGS,
  KEY_REPORTS_MEDIA_LOGS,
  KEY_REPORTS_SCREENSHOT,
  KEY_USERS_MANAGEMENTS,
  KEY_USERS_MANAGEMENTS_ROLES,
  KEY_USERS_MANAGEMENTS_USERS,
} from "@static/PERMISSION_KEY";

export const MENU_LIST = [
  {
    key: KEY_DASHBOARD,
    label: "Dashboard",
    location: "/dashboard",
  },
  { key: KEY_MEDIAS, label: "Media", location: "/medias", isChildren: false },

  {
    key: KEY_CAMPAIGNS,
    label: "Campaigns",
    location: "/campaigns",
    isChildren: false,
  },
  {
    key: KEY_IMPORTANT,
    label: "Important",
    location: "/important",
    isChildren: false,
  },
  {
    key: KEY_DEVICE_MANAGEMENT,
    label: "Device",
    isChildren: true,
    children: [
      // {
      //   key: KEY_DEVICE_MANAGEMENT_CUSTOMERS,
      //   label: "Customers",
      //   location: "/customers",
      // },
      // {
      //   key: KEY_DEVICE_MANAGEMENT_PROJECT,
      //   label: "Projects",
      //   location: "/projects",
      // },
      // {
      //   key: KEY_DEVICE_MANAGEMENT_BUILDINGS,
      //   label: "Buildings",
      //   location: "/buildings",
      // },
      // {
      //   key: KEY_DEVICE_MANAGEMENT_FLOORS,
      //   label: "Floors",
      //   location: "/floors",
      // },
      // { key: "DEVICE-MANAGEMENT_FLOORS", label: "Floors", location: "/floors" },
      {
        key: KEY_DEVICE_MANAGEMENT_DEVICES,
        label: "Devices",
        location: "/devices",
      },
      {
        key: KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS,
        label: "Device Groups",
        location: "/device-groups",
      },
    ],
  },
  {
    key: KEY_REPORTS,
    label: "Reports",
    isChildren: true,
    children: [
      {
        key: KEY_REPORTS_ACTION_LOGS,
        label: "Action logs",
        location: "/action-logs",
      },
      {
        key: KEY_REPORTS_MEDIA_LOGS,
        label: "Media logs",
        location: "/media-logs",
      },
      {
        key: KEY_REPORTS_SCREENSHOT,
        label: "Screenshot",
        location: "/screenshot",
      },
    ],
  },
  {
    key: KEY_MANAGEMENT,
    label: "Management",
    isChildren: true,
    children: [
      {
        key: KEY_DEVICE_MANAGEMENT_CUSTOMERS,
        label: "Customers",
        location: "/customers",
      },
      {
        key: KEY_DEVICE_MANAGEMENT_PROJECT,
        label: "Projects",
        location: "/projects",
      },
      {
        key: KEY_DEVICE_MANAGEMENT_BUILDINGS,
        label: "Buildings",
        location: "/buildings",
      },
      {
        key: KEY_DEVICE_MANAGEMENT_FLOORS,
        label: "Floors",
        location: "/floors",
      },
      { key: "DEVICE-MANAGEMENT_FLOORS", label: "Floors", location: "/floors" },
    ],
  },
  {
    key: KEY_USERS_MANAGEMENTS,
    label: "User",
    isChildren: true,
    children: [
      { key: KEY_USERS_MANAGEMENTS_ROLES, label: "roles", location: "/roles" },
      { key: KEY_USERS_MANAGEMENTS_USERS, label: "users", location: "/users" },
    ],
  },
];

export const MAPPING_LOCATION_TO_MENU_KEY = {
  dashboard: KEY_DASHBOARD,
  customers: KEY_MANAGEMENT,
  projects: KEY_MANAGEMENT,
  buildings: KEY_MANAGEMENT,
  floors: KEY_MANAGEMENT,
  devices: KEY_DEVICE_MANAGEMENT,
  "devices-list": KEY_DEVICE_MANAGEMENT,
  "device-groups": KEY_DEVICE_MANAGEMENT,
  "device-groups-list": KEY_DEVICE_MANAGEMENT,
  "devices-prediction": KEY_DEVICE_MANAGEMENT,
  important: KEY_IMPORTANT,
  "important-list": KEY_IMPORTANT,
  "important-blocks": KEY_IMPORTANT,
  prediction: KEY_DEVICE_MANAGEMENT,
  campaigns: KEY_CAMPAIGNS,
  "campaigns-list": KEY_CAMPAIGNS,
  "campaign-blocks": KEY_CAMPAIGNS,
  medias: KEY_MEDIAS,
  "medias-list": KEY_MEDIAS,
  reports: KEY_REPORTS,
  "media-logs": KEY_REPORTS,
  "action-logs": KEY_REPORTS,
  screenshot: KEY_REPORTS,
  roles: KEY_USERS_MANAGEMENTS,
  users: KEY_USERS_MANAGEMENTS,
};
